import { ViewActivitiesDate, clintActivityFormatTime } from '@/functions';
import React from 'react';
import { Button, Col, Grid, Pagination, Row, Table } from 'rsuite';
const { Column, HeaderCell, Cell } = Table;
function CustomTable({ data = [], page, setPage, meta, setDrawerOpen, setSelectedTableData }) {
  const handleChangeLimit = () => {
    setPage(1);
  };
  const columns = [
    {
      label: 'S.no',
      key: 'id',
      width: 80,
      fixed: true,
      renderCell: (_, rowIndex) => {
        return rowIndex + 1;
      }
    },
    {
      label: 'Visitor details',
      key: 'visitordetails',
      width: 400,
      fixed: false,
      renderCell: rowData => renderVisitorDetails(rowData)
    },
    {
      label: 'Location',
      key: 'location',
      width: 100,
      fixed: false,
      renderCell: rowData => {
        return rowData.location;
      }
    },
    {
      label: 'Spend Time',
      key: 'over-all-time',
      width: 150,
      fixed: false,
      renderCell: rowData => {
        return clintActivityFormatTime(rowData.timespent);
      }
    },

    {
      label: 'Activity Summary',
      key: 'Opened',
      fixed: false,
      colSpan: 4,
      width: 150,
      renderCell: rowData => {
        const countByProductId = {};
        const encounteredIds = new Set();
        let totalCount = 0;
        rowData?.openedproduct?.forEach(item => {
          if (!encounteredIds.has(item.productid)) {
            countByProductId[item.productid] = (countByProductId[item.productid] || 0) + 1;
            encounteredIds.add(item.productid);
            totalCount++;
          }
        });
        return (
          <div className="activity-data">
            <h6>Opened</h6>
            <span>{totalCount}</span>
          </div>
        );
      }
    },
    {
      key: 'Selected',
      fixed: false,
      width: 150,
      renderCell: rowData => {
        return (
          <div className="activity-data">
            <h6>Selected</h6>
            <span>{rowData.shortlistproduct.length}</span>
          </div>
        );
      }
    },
    {
      key: 'Send Query',
      fixed: false,
      width: 150,
      renderCell: rowData => {
        return (
          <div className="activity-data">
            <h6>Send Query</h6>
            <span>{rowData.sentquery.length}</span>
          </div>
        );
      }
    },
    {
      key: 'Send Query',
      width: 150,
      fixed: false,
      renderCell: rowData => renderActivitysummary(rowData, setDrawerOpen, setSelectedTableData)
    }
  ];
  return (
    <>
      <Table
        bordered
        cellBordered
        height={400}
        rowHeight={rowData => {
          if (
            rowData?.loginemail != null &&
            rowData?.loginmobile != null &&
            rowData?.loginusername != null
          ) {
            return 100;
          } else if (
            (rowData?.loginemail != null && rowData?.loginmobile != null) ||
            (rowData?.loginmobile != null && rowData?.loginusername != null) ||
            (rowData?.loginemail != null && rowData?.loginusername != null)
          ) {
            return 90;
          } else {
            return 60;
          }
        }}
        wordWrap
        data={data}
      >
        {columns.map(({ label, key, renderCell, width, fixed, colSpan }) => {
          return (
            <Column
              width={key == 'visitordetails' || key == 'id' ? width : null}
              fixed={fixed}
              key={key}
              colSpan={colSpan}
              align={key == 'visitordetails' ? 'left' : 'center'}
              flexGrow={key == 'id' || key == 'visitordetails' ? null : 1}
            >
              <HeaderCell style={{ fontSize: '14px', fontWeight: 'bold' }}>{label}</HeaderCell>
              <Cell dataKey={key}>
                {(rowData, index) => (renderCell ? renderCell(rowData, index) : rowData[key])}
              </Cell>
            </Column>
          );
        })}
      </Table>
      <div style={{ padding: 20 }}>
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={5}
          limit={25}
          size="xs"
          layout={['-', 'pager', 'skip']}
          total={meta?.pagination?.total || 1}
          activePage={page}
          onChangePage={setPage}
          onChangeLimit={handleChangeLimit}
        />
      </div>
    </>
  );
}
export default React.memo(CustomTable);

const renderVisitorDetails = rowData => {
  const { loginusername, loginmobile, loginemail, logintime, updatedAt } = rowData;
  const visitorInfo1 = loginusername ? loginusername : null;
  const visitorInfo2 = loginmobile ? loginmobile : null;
  const visitorInfo3 = loginemail ? loginemail : null;
  const timeDifference = new Date().getTime() - new Date(updatedAt).getTime();
  const minutesDifference = Math.floor(timeDifference / (1000 * 60));
  const isOnline = minutesDifference <= 1;
  return (
    <div className="visitordetails">
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div>
          {visitorInfo1 && <h6>{visitorInfo1}</h6>}
          {visitorInfo2 && <h6>{visitorInfo2}</h6>}
          {visitorInfo3 && <h6>{visitorInfo3}</h6>}
        </div>
        {isOnline ? <span className={'live'}>Live</span> : null}
      </div>

      <span>{ViewActivitiesDate(logintime)}</span>
    </div>
  );
};

const renderActivitysummary = (rowData, setDrawerOpen, setSelectedTableData) => {
  return (
    <Button
      size="sm"
      onClick={() => {
        setDrawerOpen(true);
        setSelectedTableData(rowData);
      }}
      active
      appearance="default"
    >
      View details
    </Button>
  );
};
